<template>
  <router-link :to="projectLink">
    <card dis-hover :padding="8" class="contragent-item">
      <div class="contragent-item__left">
        <tag class="status" :color="getContractStatusColor(contragent.status)">
          {{ contragent.status }}
        </tag>
        <div class="contragent-item__main-info">
          <div class="contragent-item__name ms-subhead ms-ellipsis">
            Компания: {{ contragent.performer }}
          </div>
          <div class="contragent-item__stage ms-help">
            №{{ contragent.number }} от {{ contragent.sign_date }}
          </div>
        </div>
      </div>
      <div class="contragent-item__center">
        <div class="contragent-item__dates">
          <div class="contragent-item__date start">
            <span class="ms-help">
              Начало: {{ formatDefaultDate(contragent.start_date) }}
            </span>
          </div>
          <div class="contragent-item__date end">
            <span class="ms-help">
              Окончание: {{ formatDefaultDate(contragent.end_date) }}
            </span>
          </div>
        </div>
        <div class="contracts-item__stats">
          <contract-progress
            label="Акты"
            :part="contragent.act_value"
            :all="contragent.costs"
          />
          <contract-progress
            label="Платежи"
            :part="contragent.already_payed"
            :all="contragent.costs"
          />
        </div>
      </div>
      <div class="contragent-item__right">
        <div class="contragent-item__status">
          <tag color="primary" class="ms-costs">
            {{
              getFormattedCosts(contragent.costs, false, contragent.with_vat)
            }}
          </tag>
        </div>
        <div class="contragent-item__job-types">
          <collapsed-job-types :job-types="contragent.job_types" />
        </div>
      </div>
    </card>
  </router-link>
</template>

<script>
import ContractProgress from '@/components/contract/info/contract-progress'
import CollapsedJobTypes from '@/components/parts/collapsed-job-types'
import {
  getFormattedCosts,
  getContractStatusColor,
  formatDefaultDate
} from '@/utils'

export default {
  props: ['contragent'],
  components: {
    CollapsedJobTypes,
    ContractProgress
  },
  computed: {
    projectLink () {
      const { performer_is_own, id } = this.contragent
      const type = performer_is_own ? 'contracts' : 'contragents'

      return `/app/${type}/${id}`
    }
  },
  methods: {
    getContractStatusColor,
    getFormattedCosts,
    formatDefaultDate
  }
}
</script>

<style lang="less">
.contragent-item {
  margin-bottom: 8px;

  &:hover {
    border-color: rgba(@primary-color, 0.6) !important;
  }

  .ivu-card-body {
    display: flex;
    justify-content: space-between;
    align-items: center;

    a {
      display: flex;
      align-items: center;

      .contragent-item__name {
        margin-left: 8px;
      }
    }
  }

  &__left {
    width: 30%;
    box-sizing: border-box;
    display: flex;

    .ivu-tag {
      flex-shrink: 0;
      width: 112px !important;
      min-width: 96px;
      height: 40px;
      line-height: 40px;
      margin: 0;
    }
  }
  &__center {
    flex-shrink: 0;
    margin: 0 32px;
    box-sizing: border-box;
  }
  &__right {
    width: 25%;
    box-sizing: border-box;
  }

  &__main-info {
    margin-left: 16px;
  }

  &__name {
    width: 320px;
  }

  &__stage {
    width: 320px;
  }

  &__statuses {
    display: flex;
    justify-content: flex-end;
  }

  &__job-types {
    text-align: right;
    margin-top: 4px;

    .ivu-tag {
      margin-right: 0;
      margin-left: 4px;
    }
  }

  &__costs {
    margin-left: 16px;

    .ivu-tag {
      margin-right: 0;
    }
  }

  &__dates {
    display: flex;
    justify-content: flex-end;

    .end {
      margin-left: 16px;
    }
  }
}
</style>
